/* SNUG scroll-lock guard — auto-releases a stale body scroll-lock (cart drawer 'drawer-opened'
   overflow:hidden, or a leaked inline lock) when no drawer/modal is actually VISIBLE.
   Fixes "page freezes, must refresh to scroll". Visibility-checked so it never unlocks a real open drawer. */
(function(){
  function vis(el){ if(!el) return false; var s=getComputedStyle(el); return el.offsetParent!==null && s.visibility!=='hidden' && s.display!=='none'; }
  function noneOpen(){
    var els=document.querySelectorAll('.go-cart__drawer.is-open, .drawer.is-open, .is-open[class*="cart"], .is-open[class*="drawer"], .is-open[class*="modal"], [aria-modal="true"]');
    for(var i=0;i<els.length;i++){ if(vis(els[i])) return false; }
    return true;
  }
  function release(){
    var b=document.body; if(!b) return;
    if(noneOpen()){
      if(b.classList.contains('drawer-opened')) b.classList.remove('drawer-opened');
      if(b.style.overflowY==='hidden') b.style.overflowY='';
      if(b.style.overflow==='hidden') b.style.overflow='';
      if(b.style.position==='fixed'){ b.style.position=''; b.style.top=''; }
    }
  }
  setInterval(release,700);
  document.addEventListener('keydown',function(e){ if(e.key==='Escape') setTimeout(release,60); });
  document.addEventListener('click',function(){ setTimeout(release,300); },true);
})();
